module.exports = __webpack_public_path__ + "img/Kazune.f233ec16.jpg";